"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewPaymentSheet extends new_item_1.default {
    constructor(newPaymentSheet) {
        super();
        this.setupIntent = newPaymentSheet.setupIntent;
        this.ephemeralKey = newPaymentSheet.ephemeralKey;
        this.customer = newPaymentSheet.customer;
        this.publishableKey = newPaymentSheet.publishableKey;
    }
}
exports.default = NewPaymentSheet;
//# sourceMappingURL=new-paymentSheet.js.map